
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pregnancyoracle/duedate",
      function () {
        return require("private-next-pages/pregnancyoracle/duedate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pregnancyoracle/duedate"])
      });
    }
  